/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
import APPSETTINGS from './settings.json';

const msalClientId = APPSETTINGS.msalClientId;//import.meta.env.PROD ? APPSETTINGS.production.msalClientId : APPSETTINGS.development.msalClientId;
const msalAuthority = APPSETTINGS.msalAuthority; //import.meta.env.PROD ? APPSETTINGS.production.msalAuthority : APPSETTINGS.development.msalAuthority;
const msalKnownAuthorities = APPSETTINGS.authorityDomain;//import.meta.env.PROD ? APPSETTINGS.production.authorityDomain : APPSETTINGS.development.authorityDomain;

export const msalConfig = {
    auth: {
        clientId: msalClientId,
        redirectUri: window.location.origin,
        authority: msalAuthority,
        knownAuthorities: msalKnownAuthorities
    },
    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: import.meta.env.PROD ? {} : {
            loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            }
        }
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: []
};
